import React, { useState, useEffect } from 'react';
import {
  Center,
  Spinner,
  Flex,
  Text,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
} from '@chakra-ui/react';
import { EditIcon, CloseIcon } from '@chakra-ui/icons';
import { useAuth } from '../../../../auth-context/auth.context';
import SavingsPlanApi from 'api/savingplan';
import { categoryMap } from 'config/constant';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { MetalTypesOptions } from 'config/constant';
import TextAreaField from 'components/formComponents/textAreaField';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import PageError from 'components/nopermission/PageError';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { isValidUUID } from 'utils/fetchUtils';

export default function EditSavingPlan() {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const { user } = useAuth();
  const [disabled, setDisabled] = useState(true);
  const { getPermissionsForModule } = usePermissions();
  const [savingPlanPermissions, setsavingPlanPermissions] = useState(null);
  const [fetchSavingsPlanDataError, setFetchSavingsPlanDataError] =
    useState(false);
  const savingsPlanId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  // Form States
  const [savingsPlanData, setSavingsPlanData] = useState();

  const FetchSavingsPlanData = async () => {
    if (!isValidUUID(savingsPlanId)) {
      setFetchSavingsPlanDataError(true);
      return;
    }
    try {
      setLoading(true);
      const response = await SavingsPlanApi.getById(savingsPlanId);
      setLoading(false);
      console.log('response of getby id', response);
      if (response.data.status_code === 200) {
        setFetchSavingsPlanDataError(false);
        const data = response.data.data;
        setSavingsPlanData(data);
      } else {
        setFetchSavingsPlanDataError(true);
        setSavingsPlanData({});
      }
    } catch (err) {
      setLoading(false);
      setFetchSavingsPlanDataError(true);
      console.error(err);
    }
  };

  useEffect(() => {
    const savingPlanPermissions = getPermissionsForModule([Modules.SavingPlan]);
    setsavingPlanPermissions(savingPlanPermissions);
  }, [savingsPlanId, getPermissionsForModule]);

  useEffect(() => {
    if (savingsPlanId && savingPlanPermissions?.read) {
      FetchSavingsPlanData();
    }
  }, [savingsPlanId, savingPlanPermissions]);

  const handleUpdate = async (values) => {
    try {
      const response = await SavingsPlanApi.Update({
        savingsPlanId,
        ...values,
      });
      if (response.data.status_code === 200) {
        toast({
          title: response.data.message || 'Successfully Updated',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        setDisabled(true);
      } else {
        toast({
          title: response.data.message || 'Error Updating',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.error(err);
      toast({
        title: 'Error Updating',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  const validationSchema = Yup.object({
    type: Yup.string().required('Type is required'),
    category: Yup.string().required('Category is required'),
    order: Yup.string().required('Display Order is required'),
    isActive: Yup.string().required('Status is required'),
    description: Yup.string()
      .trim()
      .required('A short description is required'),
  });
  console.log('permissions', savingPlanPermissions);

  if (!savingPlanPermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlan} />;
  }
  return loading ? (
    <Center
      mt='10rem'
      width='100%'
      // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : fetchSavingsPlanDataError ? (
    <PageError />
  ) : (
    <>
      <Flex
        alignItems='center'
        mt='7rem'
        mb={10}
        justifyContent='flex-end'>
        {/* <Text fontSize='3xl' fontWeight='400'>
          About - {savingsPlanData.name}
        </Text> */}
        {savingPlanPermissions?.update ? (
          disabled ? (
            <EditIcon
              ml='5'
              fontSize='large'
              onClick={() => setDisabled(false)}
              cursor='pointer'
            />
          ) : (
            <CloseIcon
              ml='5'
              fontSize='large'
              onClick={() => setDisabled(true)}
              cursor='pointer'
            />
          )
        ) : (
          <></>
        )}
      </Flex>
      <Formik
        initialValues={{
          type: savingsPlanData?.metal_type || '',
          category: savingsPlanData?.category || '',
          order: savingsPlanData?.display_order || '',
          isActive: savingsPlanData?.is_active ? 'true' : 'false',
          description: savingsPlanData?.short_details.text || '',
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleUpdate(values);
        }}>
        {({ values, handleChange }) => (
          <Form noValidate>
            <Flex direction='column'>
              <FormControl mt={5}>
                <FormLabel>
                  <Text
                    fontSize='md'
                    fontWeight='50'>
                    Category
                  </Text>
                </FormLabel>
                <Flex
                  alignItems='center'
                  mt={-2}>
                  <Field
                    as={Select}
                    name='category'
                    disabled={disabled}
                    value={values.category}
                    onChange={handleChange}>
                    {categoryMap.map((element) => (
                      <option
                        key={element.value}
                        value={element.value}>
                        {element.label}
                      </option>
                    ))}
                  </Field>
                </Flex>
              </FormControl>
              <FormControl mt={3}>
                <FormLabel>
                  <Text
                    fontSize='md'
                    fontWeight='50'>
                    Type
                  </Text>
                </FormLabel>
                <Flex
                  alignItems='center'
                  mt={-2}>
                  <Field
                    as={Select}
                    name='type'
                    variant={disabled ? 'authNoBorder' : 'auth'}
                    disabled={disabled}
                    value={values.type}
                    onChange={handleChange}>
                    {MetalTypesOptions.map((type) => (
                      <option
                        key={type.value}
                        value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </Field>
                </Flex>
              </FormControl>
              <FormControl mt={3}>
                <FormLabel>
                  <Text
                    fontSize='md'
                    fontWeight='50'>
                    Display Order
                  </Text>
                </FormLabel>
                <Flex
                  alignItems='center'
                  mt={-2}>
                  <Field
                    as={Input}
                    name='order'
                    variant={disabled ? 'authNoBorder' : 'auth'}
                    type='Text'
                    disabled={disabled}
                    maxLength='100'
                    value={values.order}
                    onChange={handleChange}
                  />
                </Flex>
              </FormControl>
              <TextAreaField
                label='Short Description of the Plan'
                name='description'
                type='text'
                disabled={disabled}
                placeholder='Upto 200 Characters'
                required
              />
              <FormControl mt={3}>
                <FormLabel>
                  <Text
                    fontSize='md'
                    fontWeight='50'>
                    Status
                  </Text>
                </FormLabel>
                <Flex
                  alignItems='center'
                  mt={-2}>
                  <Field
                    as={Select}
                    name='isActive'
                    variant={disabled ? 'authNoBorder' : 'auth'}
                    disabled={disabled}
                    value={values.isActive}
                    onChange={handleChange}>
                    <option value='true'>Active</option>
                    <option value='false'>Inactive</option>
                  </Field>
                </Flex>
              </FormControl>
              {savingPlanPermissions?.update && (
                <FormControl mt={5}>
                  <Button
                    colorScheme='blue'
                    disabled={disabled}
                    type='submit'>
                    Update
                  </Button>
                </FormControl>
              )}
            </Flex>
          </Form>
        )}
      </Formik>
    </>
  );
}
